export default {
	data() {
		return {
			isInfoPage: false,
			editorVisibleRecv: false,
			itemTableFields: [
				{
					name: "product_color",
					isOnlyShow: true,
				},
				{
					name: "color",
					isOnlyShow: true,
				},
				{
					name: "model",
					isOnlyShow: true,
				},
				{
					name: "price_per",
				},
				{
					name: "amount",
				},
				{
					name: "total_price",
					isOnlyShow: true,
				},
			],
			sendFields: [
				{
					name: "show_id",
					width: "100%",
					isOnlyShow: true,
				},
				{
					name: "name",
					width: "100%",
					isOnlyShow: true,
				},
				{
					name: "express",
					width: "100%",
					rules: ["required"],
				},
				{
					name: "tracking_number",
					rules: ["required"],
				},
				{
					name: "mobile_tail_no",
					rules: ["required"],
				},
				{
					name: "desc",
				},
			],
			getFields: [
				{
					name: "express",
					width: "100%",
					rules: ["required"],
				},
				{
					name: "tracking_number",
					rules: ["required"],
				},
				{
					name: "mobile_tail_no",
					rules: ["required"],
				},
				{
					name: "desc",
				},
			],
			sendFieldsRecv: [
				{
					name: "show_id",
					width: "100%",
					isOnlyShow: true,
				},
				{
					name: "status",
					width: "100%",
					isOnlyShow: true,
				},
				{
					name: "name",
					width: "100%",
					isOnlyShow: true,
				},
				{
					name: "express",
					width: "100%",
					rules: ["required"],
				},
				{
					name: "tracking_number",
					rules: ["required"],
				},
				{
					name: "mobile_tail_no",
					rules: ["required"],
				},
				{
					name: "desc",
				},
			],
		};
	},
	methods: {
		hasEdit(info) {
			if (info._id == "") {
				return false;
			}
			if (info.type.index == 21 && info.status.index == 11) {
				return true;
			} else if (info.type.index == 20 && info.status.index == 10) {
				//出库不可编辑
				return false;
			} else if (info.type.index == 31 && info.status.index == 11) {
				return true;
			} else if (info.type.index == 40 && info.status.index == 11) {
				return true;
			} else if (info.type.index == 24 && info.status.index == 11) {
				return true;
			}
			return false;
		},
		goTxInfo(id) {
			// debugger;
			const { href } = this.$router.resolve({
				name: "Tx-Info",
				params: {
					id: id,
					tab: "info",
				},
			});
			window.open(href, "_blank");
		},
		goTxEdit(id) {
			// debugger;
			if (this.$route.name == "Tx-Info") {
				this.$router.push({
					name: "Tx-Info",
					params: {
						id: id,
						tab: "edit",
					},
				});
			} else {
				const { href } = this.$router.resolve({
					name: "Tx-Info",
					params: {
						id: id,
						tab: "edit",
					},
				});
				window.open(href, "_blank");
			}
		},
		handlerPost(type) {
			if (this.info.items.length <= 0) {
				this.$message.error("尚未录入货单");
				return;
			}
			// if (this.info.items.length > 200) {
			// 	this.$message.error("最多200种商品");
			// 	return;
			// }
			this.$refs["form"].validate(valid => {
				if (!valid) {
					this.$message.error("请检查输入");
					return false;
				}
				if (type == "edit_verify") {
					this.$confirm("保存并实际完成入库操作, 无法继续修改，是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
						.then(() => {
							this._doPost("edit_verify");
						})
						.catch(() => {
							this.$message({
								type: "info",
								message: "已取消",
							});
						});
				} else {
					this._doPost(type);
				}
			});
		},
		goRejectTx(id) {
			this.$confirm("取消出库状态，重新修改订单？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					const url = `/inventory/do_tx_reject/${id}`;

					this.loadings.main = true;
					this.$axios
						.post(url, {})
						.then(json => {
							this.loadings.main = false;
							this.$router.push({
								name: "Order-Info",
								params: {
									id: json.data.info._id,
									tab: "tx",
								},
							});
						})
						.catch(json => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		doDuplate(id) {
			const url = `/inventory/do_tx_dup/${id}`;

			this.loadings.main = true;
			this.$axios
				.post(url, {})
				.then(json => {
					this.loadings.main = false;
					this.goTxEdit(json.data.newid);
				})
				.catch(json => {
					this.loadings.main = false;
					this.$message.error(json.data.msg);
				});
		},
		doDeleteTx(id) {
			this.$confirm("删除后将无法恢复，是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					const url = `/inventory/do_tx_delete/${id}`;

					this.loadings.main = true;
					this.$axios
						.post(url, {})
						.then(json => {
							this.loadings.main = false;
							if (this.isInfoPage) {
								this.$router.push({
									name: "Inventory-Inbound",
									params: {
										tab: "his",
									},
								});
							} else {
								this.refreshTable();
							}
						})
						.catch(json => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		doHasVerify(id) {
			this.$confirm("实际完成库存操作, 无法继续修改，是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					const url = `/inventory/do_tx_edit/verify/${id}`;

					this.loadings.main = true;
					this.$axios
						.post(url, {})
						.then(json => {
							this.loadings.main = false;
							if (this.isInfoPage) {
								this.setData(json.data);
							}

							this.$router.push({
								name: "Tx-Info",
								params: {
									id: json.data.info._id,
									tab: "info",
								},
							});
						})
						.catch(json => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
			//confirm first
		},
		goSendTx(id) {
			this.editorId = id;
			this.editorVisible = true;
		},
		goRecvTx(id) {
			this.editorId = id;
			this.editorVisibleRecv = true;
		},
		goSendTxy(id) {
			this.editorIds = id;
			this.editorVisibles = true;
		},
		doRecvTx(id) {
			this.$confirm("确认收货将关闭本出库单和关联的订单，是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					const url = `/inventory/do_tx_op/recv/${id}`;

					this.loadings.main = true;
					this.$axios
						.post(url, this.info)
						.then(json => {
							this.loadings.main = false;
							if (this.isInfoPage) {
								this.setData(json.data);
							} else {
								this.refreshTable("listTable");
							}
						})
						.catch(json => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		doPrint() {
			window.print();
		},
	},
};
